import React, { useState, useEffect, useRef } from 'react';
import { oggiData } from './funzioni.js'
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import TendinaGiorni from "./TendinaGiorni";
import ToastSuccesso from './ToastSuccesso.js'
import { haPersonalizzazione } from '../funzioni.js';

function PrenotazioniCorsiOggi(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "impostaFiltri": 2,
        "creaReport": 3,
        "visualizzaReport": 4,
        "richiestaConfermaPrenotazione": 5,
        "richiestaConfermaListaAttesa": 6,
        "mostraToast": 7
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [datiReport, setDatiReport] = useState([]);
    const [idCorsoSelezionato, setIdCorsoSelezionato] = useState("");
    const [nomeCorsoSelezionato, setNomeCorsoSelezionato] = useState("");
    const [dataInizio, setDataInizio] = useState("");
    const [dataFine, setDataFine] = useState("");
    const [giornoSelezionato, setGiornoSelezionato] = useState("");
    const [aux, setAux] = useState("")

    const timeoutToast = useRef(null);

    const [toast, setToast] = useState({
        visibile: false,
        testo: "",
        tipo: "verde"
    });
    
    useEffect(() => {
        setPagina(PAGINE.creaReport);
        var gs = oggiData();
        if (props.giorno) gs = props.giorno;
        setGiornoSelezionato(gs);
        ottieniElencoCorsi(gs); // va usato il parametro perché qui la var di stato giornoSelezionato non è ancora settata
    }, [])

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])  

    function mostraToast(testo, tipo, flagEsci=false) {
        var tempoTimeout = 2000;
        if (tipo === "rosso") tempoTimeout = 3000;
        if (timeoutToast.current !== null) {
            clearTimeout(timeoutToast.current);
        }

        setToast({
            visibile: true,
            testo: testo,
            tipo: tipo
        });
        setPagina(PAGINE.mostraToast);

        timeoutToast.current = setTimeout(() => {
            setToast({
                visibile: false,
                testo: "",
                tipo: "verde"
            });
            if (flagEsci) props.callback(props.PAGINECLIENTI.prenotazioniMenu);
            else {
                setPagina(PAGINE.creaReport);
                ottieniElencoCorsi();
            }

            timeoutToast.current = null;
        }, tempoTimeout);
    }

    function prenota() {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                op:"prenotazioneCorsiIns", 
                idCorso:idCorsoSelezionato, 
                dataInizio:dataInizio,
                dataFine:dataFine,
                note: "", 
                aux: aux,
                emak: props.emak, 
                sessionId: props.sessionId 
            })
        };
        fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
        (valoreRitorno) => {
            if (valoreRitorno.verifvers===0) {
                // necessario aggiornare la app
                props.callbackAggiornaApp();
                return;
            }
            if (valoreRitorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
            if (valoreRitorno.risultatoOperazione==1) {
                mostraToast("Prenotazione memorizzata", "verde", true);
            } else {
                var errore="";
                if (valoreRitorno.mess!=undefined) errore = valoreRitorno.mess;
                switch (errore) {
                    
                    case "Prenotazione non inserita in quanto rientrerebbe nel periodo di disdetta non consentito":              
                        mostraToast("PRENOTAZIONE FALLITA: non è possibile prenotare a meno di " + valoreRitorno.stringa_tempo_annullamento + " da adesso", "rosso", true);
                    break;

                    case "Nessun posto disponibile":              
                        mostraToast("PRENOTAZIONE FALLITA: i posti che erano disponibili nell'intervallo selezionato sono stati occupati oppure è necessario un abbonamento specifico", "rosso", true);
                    break;

                    default:
                    mostraToast(
                        errore !== "" 
                            ? errore 
                            : "PRENOTAZIONE FALLITA: la prenotazione non è stata memorizzata. Riprovare o contattare l'assistenza.",
                        "rosso",
                        true
                    );
                }
            }
            //setPagina(props.PAGINECLIENTI.prenotazioniMenu);
        },
        (error) => { 
            props.callback(props.PAGINECLIENTI.login);
            return;
        }
        )
        .catch(function(error) {
            props.callback(props.PAGINECLIENTI.login);
            return;
        });  
    }

    function entraInListaAttesa() {
        const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            op:"entraListaAttesa", 
            idCorso:idCorsoSelezionato, 
            idPersona:props.identitaSelezionata.idpersona, 
            dataInizio:dataInizio,
            dataFine:dataFine,
            emak: props.emak, 
            sessionId: props.sessionId 
        })
        };
        fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
        (valoreRitorno) => {
            if (valoreRitorno.verifvers===0) {
            // necessario aggiornare la app
            props.callbackAggiornaApp();
            return;
            }
            if (valoreRitorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
            if (valoreRitorno.risultatoOperazione==1) {
                mostraToast("Sei in lista di attesa", "verde");
            } else {
                var errore="";
                if (valoreRitorno.mess!=undefined) errore = valoreRitorno.mess;
                mostraToast(errore, "rosso", true);
                return;
            }
        },
        (error) => { 
            props.callback(props.PAGINECLIENTI.login);
            return;
        }
        )
        .catch(function(error) {
            props.callback(props.PAGINECLIENTI.login);
            return;
        });  
    }

    function elimina(oggetto, idCorso, dataInizio, dataFine) {
        var op = "";
        if (oggetto==="prenotazione") op = "prenotazioneCorsiCanc";
        if (oggetto==="lista_attesa") op = "listeAttesaCanc";
        if (op === "") return;

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            op:op, 
            idCorso:idCorso, 
            idPersona:props.identitaSelezionata.idpersona, 
            dataInizio:dataInizio, 
            dataFine:dataFine, 
            note: "", 
            emak: props.emak, 
            sessionId: props.sessionId 
          })
        };
        fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreRitorno) => {
            if (valoreRitorno.verifvers===0) {
              // necessario aggiornare la app
              props.callbackAggiornaApp();
              return;
            }
            if (valoreRitorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }        
            if (valoreRitorno.risultatoOperazione==1) {
              if (oggetto == "prenotazione") mostraToast("Prenotazione eliminata", "rosso");
              if (oggetto == "lista_attesa") mostraToast("Uscita confermata dalla lista di attesa", "rosso");
              return;
            } else {
              if (valoreRitorno.mess === "Prenotazione non eliminabile in quanto oramai entrata nel periodo di disdetta non consentito") {
                window.alert("IMPOSSIBILE ELIMINARE: non è possibile disdire prenotazioni a meno di " + valoreRitorno.stringa_tempo_annullamento + " da adesso");
              } else {
                window.alert(valoreRitorno.mess);
              }
            }
            setPagina(PAGINE.creaReport);
            ottieniElencoCorsi();
          },
          (error) => { 
            props.callback(props.PAGINECLIENTI.login);
            return; // QUI VA GESTITO COSA FARE NEL FRONTEND SE BACKEND DICE ERRORE
          }
        )
        .catch(function(error) {
          props.callback(props.PAGINECLIENTI.login);
          return;
        });  
    }

    function formattaDataConGiorno(dataStr) {
        const data = new Date(dataStr);
        // se vuoi anche l'anno, aggiungi year: "numeric" dopo day e month
        return new Intl.DateTimeFormat("it-IT", {
            weekday: "long",
            day: "numeric",
            month: "long",
        }).format(data);
    }
    
    function formattaOra(dataStr) {
        const data = new Date(dataStr);
        return new Intl.DateTimeFormat("it-IT", {
            hour: "2-digit",
            minute: "2-digit",
        }).format(data);
    }

    function Report({ datiReport }) {
        // Ordina i dati in base a DATA_INIZIO
        const datiOrdinati = [...datiReport].sort((a, b) =>
            new Date(a.DATA_INIZIO) - new Date(b.DATA_INIZIO)
        );

        return (
            <>            
            {datiOrdinati.length == 0 ? 
                "<br/>Nessuno" 
            :
                datiOrdinati.map((elemento, indice) => {
                    const dataOraISO = new Date().toISOString();
                    // escludo le lezioni passate, quelle di oggi prima di questa ora
                    if (elemento.DATA_INIZIO > dataOraISO) {
                        
                        const stessaData = elemento.DATA_INIZIO.slice(0, 10) === elemento.DATA_FINE.slice(0, 10);
                        const dataFormattata = formattaDataConGiorno(elemento.DATA_INIZIO);
                        const oraInizio = formattaOra(elemento.DATA_INIZIO);
                        const oraFine = formattaOra(elemento.DATA_FINE);
                        const postiDisponibili = elemento.POSTI_MAX - elemento.PRENOTATI;

                        return (
                            <div key={indice} style={{ marginBottom: "1em", border: elemento.INLISTAATTESA==1 ? "1px solid #aca717" : "1px solid #ccc", borderRadius: "5px" }}>
                                <div
                                    style={{
                                        fontWeight: "bold",
                                        background: elemento.INLISTAATTESA==1 ? "#f2f1be" : elemento.PRENOTATODAME==1 ? "#e0fee0" : "#eee",
                                        padding: "0.5em",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span style={{color:"#0000FF"}}>{elemento.NOME}</span>
                                        <br/>
                                        {stessaData
                                            ? <>dalle {oraInizio} alle {oraFine}</>
                                            : <>{formattaDataConGiorno(elemento.DATA_INIZIO)} {oraInizio}<br/>{formattaDataConGiorno(elemento.DATA_FINE)} {oraFine}</>
                                        }
                                        <br/>
                                        <span style={{color:postiDisponibili>0?"#00B000":"#C00000"}}>
                                            {elemento.PRENOTATODAME==1 && "Prenotato"}
                                            {elemento.PRENOTATODAME==1 && elemento.NOTE == "doppio" && " (doppio)"}
                                            {elemento.PRENOTATODAME==1 && ", "}
                                            {elemento.INLISTAATTESA==1 && "In lista di attesa, "}
                                            {postiDisponibili} posti disponibili                                            
                                        </span>
                                    </div>
                                    {postiDisponibili > 0 && elemento.PRENOTATODAME!=1 ?
                                        haPersonalizzazione(props.identitaSelezionata, "tennis_singolo_doppio") ?
                                            <>
                                            <button
                                                onClick={() => {
                                                    setIdCorsoSelezionato(elemento.ID);
                                                    setNomeCorsoSelezionato(elemento.NOME);
                                                    setDataInizio(elemento.DATA_INIZIO);
                                                    setDataFine(elemento.DATA_FINE);
                                                    setAux("tennis:singolo");
                                                    setPagina(PAGINE.richiestaConfermaPrenotazione);
                                                }}
                                                className={[stile.baVerde, stile.baNormale].join(" ")}
                                            >
                                                Singolo
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setIdCorsoSelezionato(elemento.ID);
                                                    setNomeCorsoSelezionato(elemento.NOME);
                                                    setDataInizio(elemento.DATA_INIZIO);
                                                    setDataFine(elemento.DATA_FINE);
                                                    setAux("tennis:doppio");
                                                    setPagina(PAGINE.richiestaConfermaPrenotazione);
                                                }}
                                                className={[stile.baVerde, stile.baNormale].join(" ")}
                                            >
                                                Doppio
                                            </button>
                                            </>
                                        :
                                            <button
                                                onClick={() => {
                                                    setIdCorsoSelezionato(elemento.ID);
                                                    setNomeCorsoSelezionato(elemento.NOME);
                                                    setDataInizio(elemento.DATA_INIZIO);
                                                    setDataFine(elemento.DATA_FINE);
                                                    setPagina(PAGINE.richiestaConfermaPrenotazione);
                                                }}
                                                className={[stile.baVerde, stile.baNormale].join(" ")}
                                            >
                                                Prenota
                                            </button>
                                    :
                                    <></>    
                                    }

                                    {haPersonalizzazione(props.identitaSelezionata, "liste_attesa") && postiDisponibili===0 && elemento.PRENOTATODAME!=1 && elemento.INLISTAATTESA!=1 &&
                                    <button
                                            onClick={() => {
                                                setIdCorsoSelezionato(elemento.ID);
                                                setNomeCorsoSelezionato(elemento.NOME);
                                                setDataInizio(elemento.DATA_INIZIO);
                                                setDataFine(elemento.DATA_FINE);
                                                setPagina(PAGINE.richiestaConfermaListaAttesa);
                                            }}
                                            className={[stile.baGiallo, stile.baNormale].join(" ")}
                                        >
                                            Entra in lista di attesa
                                        </button>
                                    }

                                    {elemento.PRENOTATODAME==1 &&
                                        <button
                                            className={[stile.baRosso, stile.baNormale].join(" ")}
                                            onClick={() => {if (window.confirm(`Confermi eliminazione della prenotazione ${elemento.NOME} delle ${formattaOra(elemento.DATA_INIZIO)}?`)) elimina("prenotazione",elemento.ID, elemento.DATA_INIZIO, elemento.DATA_FINE)}}
                                        >
                                            Elimina
                                        </button>
                                    }

                                    {elemento.INLISTAATTESA==1 &&
                                        <button
                                            className={[stile.baRosso, stile.baNormale].join(" ")}
                                            onClick={() => {if (window.confirm(`Confermi di voler uscire dalla lista per ${elemento.NOME} delle ${formattaOra(elemento.DATA_INIZIO)}?`)) elimina("lista_attesa",elemento.ID, elemento.DATA_INIZIO, elemento.DATA_FINE)}}
                                        >
                                            Esci
                                        </button>
                                    }

                                </div>
                            </div>
                        );
                    }
                })
            }
        </>
        );
    }

    function callbackTendinaGiorni(v) {
        setGiornoSelezionato(v);
        ottieniElencoCorsi(v);
    }

    function ottieniElencoCorsi(overrideGiorno="") {
        var giorno = giornoSelezionato;
        if (overrideGiorno!="") giorno = overrideGiorno;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoCorsiConPrenotazioni",
            emak: props.emak,
            idPersona: props.identitaSelezionata.idpersona,
            dataInizio:giorno,
            sessionId:props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione===2) { props.callback(props.PAGINECLIENTI.login); return; }
                if(valoreDiRitorno.risultatoOperazione===1){
                    console.log(valoreDiRitorno.risultatoRitorno)
                    setDatiReport(valoreDiRitorno.risultatoRitorno);
                    setPagina(PAGINE.visualizzaReport);
                }
                if(valoreDiRitorno.risultatoOperazione===0){
                    alert("Operazione fallita. Se il problema persiste, contattare l'assistenza tecnica");
                    props.callback(props.PAGINECLIENTI.home);
                }
            },
            (error) => {props.callback(props.PAGINECLIENTI.login);}
            );
    }    

    if (pagina === PAGINE.caricamentoDati || pagina === PAGINE.creaReport) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.mostraToast) {
        return (
            <div className={stile.contenitorePrincipale} style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding:10 }}>
                <ToastSuccesso
                    visibile={toast.visibile}
                    testo={toast.testo}
                    tipo={toast.tipo}
                />
            </div>
        )
    }

    if (pagina === PAGINE.visualizzaReport) {
        return (
            <div className={stile.contenitorePrincipale} style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding:10 }}>            
                <div style={{margin: "0 auto", paddingBottom: 10}}>
                    <div style={{display: "flex",flexDirection:'row',color:"#F0F0F0", fontSize:20}}>
                        <div>Corsi di&nbsp;</div>
                        <TendinaGiorni giornoSelezionato={giornoSelezionato} callback={callbackTendinaGiorni} />
                    </div>
                </div>

                {datiReport.length==0 ?
                <>
                    <div style={{paddintTop:5, paddingBottom:5, color:"#F0F0F0", textAlign: "center", fontSize:20}}>Non ci sono corsi oggi</div>                    
                </>
                :
                    <Report datiReport={datiReport} />
                }
            </div>
        )
    }

    if (pagina === PAGINE.richiestaConfermaPrenotazione || pagina === PAGINE.richiestaConfermaListaAttesa) {
        const stessaData = dataInizio.slice(0, 10) === dataFine.slice(0, 10);
        const dataFormattata = formattaDataConGiorno(dataInizio);
        const oraInizio = formattaOra(dataInizio);
        const oraFine = formattaOra(dataFine);
        return (
            <div className={stile.contenitorePrincipale} style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 10 }}>
                <div style={{ background: "#eee", padding: "1em", borderRadius: "8px" }}>
                    <div style={{ marginBottom: "1em", lineHeight: "1.6em" }}>
                        {pagina === PAGINE.richiestaConfermaPrenotazione ? "Vuoi confermare la prenotazione per:" : "Vuoi confermare l'ingresso in lista di attesa per:"}                        
                        <div style={{ marginTop: "0.5em" }}>
                            <strong>{nomeCorsoSelezionato}</strong>
                            {haPersonalizzazione(props.identitaSelezionata,"tennis_singolo_doppio") && aux==="tennis:doppio" ? " (DOPPIO)" : " (SINGOLO)"}
                            <br />
                            {stessaData ? (
                                <>
                                    <span>{dataFormattata}</span><br />
                                    <span>dalle {oraInizio} alle {oraFine}</span>
                                </>
                            ) : (
                                <>
                                    <span>{formattaDataConGiorno(dataInizio)} {oraInizio}</span><br />
                                    <span>{formattaDataConGiorno(dataFine)} {oraFine}</span>
                                </>
                            )}
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                            
                            <div className={[stile.baRossoSoft, stile.baNormale].join(" ")} onClick={() => { setPagina(PAGINE.visualizzaReport); }}>
                                <div className={stile.spazioIconaPiccola}>
                                    <img className={stile.iconaPiccolaQuadrata} src={require('./annullabianco.png')} />
                                </div>
                                Annulla
                            </div>
        
                            <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} 
                                onClick={() => {
                                    if (pagina === PAGINE.richiestaConfermaPrenotazione) prenota();
                                    if (pagina === PAGINE.richiestaConfermaListaAttesa) entraInListaAttesa();
                                    //props.callback(props.PAGINECLIENTI.home);
                                }}>
                                <div className={stile.spazioIconaPiccola}>
                                    <img className={stile.iconaPiccolaQuadrata} src={require('./okbianco.png')} />
                                </div>
                                Conferma
                            </div>
                                             
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>Errore pagina non trovata (PrenotazioniCorsiOggi)</div>
    )
}

export default PrenotazioniCorsiOggi;
